

export default {
  SET_ITEMS(state, payload) {
    state.quotes = payload
  },

  ADD_ITEM(state, payload) {
    state.quotes.push(payload)
  },

  UPDATE_ITEM(state, payload) {
      const ItemIndex = state.quotes.findIndex((p) => p.id == payload.id)
      Object.assign(state.quotes[ItemIndex], payload)
  },

  UPDATE_ITEM_STATUS(state, payload) {
    const ItemIndex = state.quotes.findIndex((p) => p.id == payload.id)
    state.quotes[ItemIndex].status = payload.status
  },

  REMOVE_ITEM(state, itemId) {
      const ItemIndex = state.quotes.findIndex((p) => p.id == itemId)
      state.quotes.splice(ItemIndex, 1)
  }
}
